export const CRM_PROPERTY_KEYS = {
  ENABLE_CRM: 'EnableCrm',
};
